import { Link } from 'react-router-dom';
import { hotSearchList } from '@/mocks/gossip';

const stats = [
  { value: '48', label: '在追热点' },
  { value: '6.8万', label: '用户观点' },
  { value: '3.2万', label: '社群成员' },
  { value: '217', label: '今日新增' },
];

export default function HomeHero() {
  return (
    <section className="relative w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20moody%20night%20cityscape%20built%20from%20soft%20bokeh%20light%20orbs%20and%20warm%20terracotta%20amber%20glow%2C%20deep%20charcoal%20background%20with%20subtle%20grain%20and%20paper%20texture%2C%20stylized%20artistic%20illustration%20rather%20than%20a%20real%20photo%2C%20strong%20dark%20contrast%20for%20white%20text%20overlay%2C%20cinematic%20wide%20composition%2C%20minimal%20detail%2C%20no%20text%20and%20no%20people&width=1600&height=1000&seq=hero-night-gossip-01&orientation=landscape"
        alt="夜晚城市光斑抽象插画，用于首屏背景"
        title="爆料吃瓜 · 深夜热点围观"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-secondary-950/72 via-secondary-950/60 to-secondary-950/85" />

      <div className="relative mx-auto flex w-full flex-col justify-center px-4 py-16 md:min-h-[610px] md:px-6 md:py-24">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-100/25 bg-background-50/10 px-3.5 py-1.5 text-[11px] font-medium tracking-wide text-background-100 backdrop-blur md:text-xs">
            <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-primary-400" />
            理性吃瓜 · 站内内容均为网友讨论，不代表事实结论
          </span>

          <h1 className="mt-6 font-heading text-4xl font-black leading-[1.1] text-background-50 md:text-[62px]">
            爆料吃瓜
            <span className="mt-3 block text-lg font-semibold tracking-wide text-background-200 md:mt-4 md:text-2xl">
              看热点 · 聊观点 · 找组织
            </span>
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-200/90 md:mt-6 md:text-base">
            把散落在各处的娱乐爆料整理成看得懂的时间线，标注来源与证据完整度。
            你可以在讨论区里跟几千人一起逐帧比对，也能在这里找到坐标一致的群聊和贴吧版面。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/topics"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line text-base" aria-hidden="true" />
              浏览热门瓜料
            </Link>
            <Link
              to="/community"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/35 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-chat-smile-2-line text-base" aria-hidden="true" />
              进入讨论区
            </Link>
          </div>

          <dl className="mt-10 grid max-w-2xl grid-cols-2 gap-x-4 gap-y-5 border-t border-background-100/20 pt-6 md:grid-cols-4">
            {stats.map((item) => (
              <div key={item.label}>
                <dt className="text-[11px] tracking-wide text-background-300/80">{item.label}</dt>
                <dd className="mt-1 font-heading text-2xl font-black text-accent-400 md:text-[28px]">
                  {item.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="mt-10 flex flex-wrap items-center gap-2 md:mt-12">
          <span className="mr-1 flex items-center gap-1.5 text-xs font-semibold text-accent-400">
            <i className="ri-flashlight-fill" aria-hidden="true" />
            热搜
          </span>
          {hotSearchList.slice(0, 5).map((item) => (
            <Link
              key={item.rank}
              to={`/topic/${item.topicId}`}
              className="whitespace-nowrap rounded-full border border-background-100/20 bg-background-50/10 px-3.5 py-1.5 text-xs text-background-100 backdrop-blur transition-colors hover:border-primary-400 hover:text-background-50"
            >
              {item.keyword}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}